export enum ControlType {
    Cooling = 1,  
    Heating = 2  
  }

export enum BatchStatus {
    New = 1,  
    Completed = 2,
    Done = 3  
  }